import { render, staticRenderFns } from "./InterestPublicInput.vue?vue&type=template&id=25b248c6&"
import script from "./InterestPublicInput.vue?vue&type=script&lang=js&"
export * from "./InterestPublicInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports